import HelpMessage from './help-message'

const LabelMessage = ({ label, help, id }) => {
  if (label.length > 0) {
    return (
      <label className="text-input-label">
        <div>{label}</div>
        <HelpMessage message={help} id={id} />
      </label>
    )
  }

  return null
}

LabelMessage.defaultProps = { label: '', help: '' }
export default LabelMessage
